import React, { useEffect, useState, useRef } from "react";
import School_port_TS from "../Term_conditions/School_port_TS";
import Mpesa_school_portal from '../Term_conditions/Mpesa_school_portal'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPerson, faPersonDress, faXmark } from '@fortawesome/free-solid-svg-icons';

function School_Portal({school_portal}) {

  const [school_portTS, setSPTS] = useState(false)
  const [mpesa, setMpesa] = useState(false)
  const school_port_TS_Ref = useRef(null);
  const mpesa_port_Ref = useRef(null);
  const [subbtn, setSubbtn] = useState(false)

  const [school_name, setSchoolname] = useState()
  const [location, setLocation] = useState()
  const [adress, setAdress] = useState()
  const [email, setEmail] = useState()
  const [contact, setContact] = useState()
  const [contacteename, setContacteename] = useState()
  const [intakedirecto, setIntakedirector] = useState()
  const [paymentg, setPaymentg] = useState()

  const sub = () =>{
    school_port_TS_Ref.current.scrollIntoView({ behavior: 'smooth' });
  }

  useEffect(()=>{
    if(school_name&&location&&adress&&email&&contact&&contacteename&&intakedirecto&&paymentg)
    {
      setSubbtn(true)
    }

    else
    {
      setSubbtn(false)
    }


  },[school_name, location, adress, email, contact, contacteename, intakedirecto, paymentg])

  useEffect(()=>{

    if(mpesa==true)
      {
        mpesa_port_Ref.current.scrollIntoView({ behavior: 'smooth' });
      }

  },[school_portTS, mpesa])

  return (
    <div className='outer_SP'>

    <div className='SP_margin'>
   
    <div className='Student_portal'>
    <p className='fill_In'>Fill In</p>
        <input placeholder='Name of School'
         onChange={(event) => setSchoolname(event.target.value)} />
        <input placeholder='Location'
         onChange={(event) => setLocation(event.target.value)} />
        <input placeholder='Adress' 
        onChange={(event) => setAdress(event.target.value)} />
        <input type='email' placeholder='email'
        onChange={(event) => setEmail(event.target.value)} />
        <input placeholder='Contact'
        onChange={(event) => setContact(event.target.value)} />
        <input placeholder='Contactee name'
        onChange={(event) => setContacteename(event.target.value)} />
        <input placeholder='Intake director'
        onChange={(event) => setIntakedirector(event.target.value)} />
        <input placeholder='Payment Gateway'
        onChange={(event) => setPaymentg(event.target.value)} />

        {subbtn?(<div className='submit' onClick={sub}>Submit</div>):('')}
        
        
    </div>
    <div className='T_C' ref={school_port_TS_Ref}>
       <School_port_TS 
       mpesa={setMpesa}
       school_name={school_name}
       location={location}
       adress={adress}
       email={email}
       contact={contact}
       contacteename={contacteename}
       intakedirecto={intakedirecto}
       paymentg={paymentg}
        /> 
    </div>
    <div className='MPESA_SP' ref={mpesa_port_Ref}>
       <Mpesa_school_portal
          mpesa={setMpesa}
          school_name={school_name}
          location={location}
          adress={adress}
          email={email}
          contact={contact}
          contacteename={contacteename}
          intakedirecto={intakedirecto}
          paymentg={paymentg} />
    </div>
    </div>
    </div>
  )
}

export default School_Portal
